import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";


export const styles = (theme: Theme) => {
	return ({
		header: {
			margin: 0,
		},
		criteriaLabel: {
			display: "inline-block",
			fontWeight: "normal",
			marginRight: 10,
			fontSize: "0.9em",
		},
		criterion: {
			marginRight: 7,
			borderRadius: 20,
		},
		criterionSeparator: {
			display: "inline-block",
			fontWeight: "bold",
			marginLeft: 7,
			marginRight: 7,
			fontSize: "0.9em",
		},
		nlsChip: {
			height: 32,
			backgroundColor: theme.palette.primary.faded,
			borderRadius: 16,
			padding: theme.spacing(1, 2),
			gap: theme.spacing(1.25),
			display: "inline-flex",
			alignItems: "center",
			marginBottom: theme.spacing(1),
			"& .MuiChip-label": {
				fontSize: 14,
				lineHeight: "20px",
				fontFamily: theme.typography.fontFamily,
				fontWeight: 400,
				// FLAG (MAX-3909 landmine 5): pre-existing no-op — `theme.palette.text` is the TypeText
				// object, emits `color: [object Object]` (ignored by the browser). Preserved as-authored.
				color: theme.palette.text as unknown as string,
				padding: 0,
			},
			"& .MuiChip-icon": {
				margin: 0,
				width: 16,
				height: 16,
				color: theme.palette.primary.main,
			},
		},
		nlsChipLabel: {
			whiteSpace: "normal",
			overflow: "visible",
			textOverflow: "unset",
		},
	} satisfies Record<string, CSSObject>);
};
